// Slow editorial marquee ribbon (CSS keyframe based, no extra deps).
const WORDS = [
  "Meghalaya",
  "Sikkim",
  "Bhutan",
  "Arunachal",
  "Nepal",
  "Nagaland",
  "Assam",
  "Darjeeling",
  "Manipur",
  "Mizoram",
  "Tripura",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="relative overflow-hidden border-y border-[var(--tx-border)] bg-[var(--tx-bg-2)] py-8">
      <div className="flex w-max animate-[tx-marquee_38s_linear_infinite] whitespace-nowrap">
        {row.map((w, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-6xl font-light text-[var(--tx-text)]/85 mx-8 flex items-center gap-8"
          >
            {w}
            <span className="text-[var(--tx-gold)] text-2xl">✦</span>
          </span>
        ))}
      </div>
      <style>{`
        @keyframes tx-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
